import { Col, Icon, message, Progress, Row, Spin, Tooltip } from 'antd';
import { post_response } from 'helper/request';
import React, { Component, useEffect, useState } from 'react';
import { connect } from "react-redux";
import '../../../asset/style/workflow/slide.css';
import { error_manager } from "../../../helper/error_manager";
import { setDeviceBusy, setDeviceIdle } from '../../../redux_actions/device_status.action';
import {
    receivedPreviewStatus,
    setDropDistancePointLength,
    setDropDistancePointOnly,
    setFocusPoints,
    setObjectiveType,
    setPreviewStatusToConfirmed,
    setScanSpeed,
    setSpecimenType,
    updatePreviewStatus
} from '../../../redux_actions/preview_status.action';
import { RegionSelectionConstants } from "../../../redux_constants/region_selection.constant";
import { ScanApiConstant } from '../../../redux_constants/scan.constant';
import { getGlobalConfig, setGlobalConfig } from "../../../utils/api";
import {
    C240ControlPanelTooltipMessageMap,
    C240SlideStatus,
    objectiveType,
    scanSpeed,
    specimenType,
    slideType,
} from '../../../utils/const';
import { GLOBAL_CONFIG } from "../../../utils/enums";
import { getStateAwareUrl, isTrue, notNull } from "../../../utils/utils";
import { comparePropsAndState } from "../../../view/c240/utils";
import { notifyError } from "../../gammaviewer/utils/display.notification";
import {
    checkInQueueSlideStatus,
    checkPreviewNotDoneSlideStatus,
} from '../c240_preview_utils';
import { drawCrossHairInitial } from '../slot_component_utils';
import {getBarcodeCrop, getOverlayedMaskForPath} from "../preview_utils";

let SPECIMEN = {
    'PAP': specimenType.PAP,
    'HE': specimenType.HNE_TISSUE,
    'IHC': specimenType.IHC,
    'BLOOD': specimenType.BLOOD,
    'BM': specimenType.BM
}

let SCAN_SPEED = {
    'Minor': scanSpeed.FAST,
    'Few': scanSpeed.MEDIUM,
    'Major': scanSpeed.SLOW,
    'ZSTACK': scanSpeed.ZSTACK,
}

let OBJECTIVE = {
    '20x': objectiveType.TWENTY_X,
    '40x': objectiveType.FORTY_X,
    '100x': objectiveType.HUNDRED_X,
}

const initialState = {
    tissueType: null,
    scanSpeed: null,
    objective: null,
    takePreview: false,
    isFetching: false,
}

const BarcodeView = React.memo((props) => {
    let {
        slotId, rack, tray, slideState,
        SlideType, deviceId, mockHalapiStr, rackStatus, barcodeCacheBusterKey
    } = props;
    const [currentRotation, setCurrentRotation] = useState(270);

    const barcodeTaken = rackStatus[rack][tray]?.barcode_taken;

    const previewCameraBarcodeUrl = getBarcodeCrop(slotId, tray, rack)
        + '?d=' + barcodeCacheBusterKey;

    if (SlideType === slideType.SLIDE_2_BY_3_INCH) {
        slotId = slotId === 0 ? 4:5;
    }
    const elpCameraBarcodeUrl = `/server/devices/${deviceId}/get_thumbnail/?rack=${rack}` +
        `&slot=${slotId}&tray=${tray}&mock_halapi=${mockHalapiStr}&d=${barcodeCacheBusterKey}`;

    let barcodeUrl, className = "centered c240-horizontal-barcode-", showElpImage = false;

    if (slideState === C240SlideStatus.INITIAL ||
        slideState === C240SlideStatus.BARCODE_ONGOING ||
        slideState === C240SlideStatus.PREVIEW_IN_QUEUE ||
        slideState === C240SlideStatus.PREVIEW_ONGOING ||
        slideState === C240SlideStatus.AUTO_SCAN_IN_QUEUE
    ) {
        showElpImage = true;
        barcodeUrl = barcodeTaken ? elpCameraBarcodeUrl : "";
        className += "empty";
    } else {
        barcodeUrl = previewCameraBarcodeUrl;
        className += "filled";
    }

    if (SlideType === slideType.SLIDE_2_BY_3_INCH) {
        className += "-2by3";
    }

    useEffect(() => {
        getBarcodeData();
    });

    const getBarcodeData = () => {
        getGlobalConfig().then(response => {
            if (response.status === 200) {
                if (notNull(response.data[GLOBAL_CONFIG.BARCODE_ROTATION_PREVIEW.key])) {
                    setCurrentRotation(parseInt(response.data[GLOBAL_CONFIG.BARCODE_ROTATION_PREVIEW.key]));
                } else {
                    setCurrentRotation(270)
                    setBarcodeData(GLOBAL_CONFIG.BARCODE_ROTATION_PREVIEW.key, 270)
                }
            }
        }).catch(err => error_manager("Failed to fetch key", err))
    }

    const setBarcodeData = (key, value) => {
        setGlobalConfig(key, value).then(res => {
            if (res.status !== 200) {
                notifyError('barcode', `Error in setting ${key}`)
            }
        }).catch(err => error_manager("Failed to set key", err))
    };

    const rotate = () => {
        const rotation = (currentRotation + 90) % 360;
        setCurrentRotation(rotation)
        setBarcodeData(GLOBAL_CONFIG.BARCODE_ROTATION_PREVIEW.key, rotation)
    }

    return (
        <Col span={8} className={className}>
            {showElpImage && !barcodeTaken ? null :
                <div className="c240-barcode-filled" onClick={rotate}>
                    <img key={Math.random()} className="barcode-image"
                        alt="Barcode" src={barcodeUrl}
                        style={{
                            cursor: 'pointer',
                            transformOrigin: "50% 50%",
                            transform: `rotate(${currentRotation}deg)`
                        }}
                    />
                    <div className="rotate"><Icon type="reload"/></div>
                </div>
            }
        </Col>
    );
})

const SlideMetaComponent = React.memo((props) => {
    let {rack, tray, slotId, scanAreaFinalized, slideStatus, previewCalibration, SlideType} = props;
    let color = "black";
    if (slideStatus === C240SlideStatus.PREVIEW_DONE) {
        color = scanAreaFinalized ? "black" : "grey";
    } else if (slideStatus === C240SlideStatus.INITIAL) {
        color = "#D2DFF3";
    } else if (checkPreviewNotDoneSlideStatus(slideStatus)) {
        color = "#3590FF"
    } else if (slideStatus === C240SlideStatus.SCAN_IN_QUEUE) {
        color = "#CEFA05";
    } else if (slideStatus === C240SlideStatus.SCAN_ONGOING) {
        color = "#CEFA05";
    } else if (slideStatus === C240SlideStatus.SCAN_STITCHING) {
        color = "#CEFA05";
    } else if (slideStatus === C240SlideStatus.SCAN_DONE) {
        color = "#3ECD32";
    } else if (slideStatus === C240SlideStatus.SCAN_CRASHED) {
        color = "red";
    }

    if (previewCalibration) {
        color = 'rgb(0 0 255 / 50%)'
    }
    return (
        <>
            <Col span={3}>
                <span>
                    {`${rack === 0 ? "R" : "L"}${tray+1}-S${slotId+1}`}
                </span>
            </Col>
            <Col span ={1} className={SlideType === slideType.SLIDE_2_BY_3_INCH ? "c240-horizontal-slide-status-2by3" : "c240-horizontal-slide-status"}
                 style={previewCalibration ? {animation: "shadow-pulse-focus 0.8s infinite", backgroundColor: color}: {backgroundColor: color}}>
            </Col>
        </>
    );
})

class C240SlideView extends Component {

    constructor(props) {
        super(props);
        this.state = initialState;
    }

    componentDidMount = () => {
        //Make SpecimenTypes Config Based
        let supportedSpecs = this.props.supportedSpecimenTypes
        let specimens_=[]
        if(supportedSpecs !== undefined && (supportedSpecs || {}).length > 0){
            this.props.supportedSpecimenTypes.map((index)=>{
                specimens_.push(index);
            })
        }
        
        Object.keys(SPECIMEN).map((specimen) => {
            if(specimen === "HE"){
                if(!(specimens_.includes("HNE_TISSUE"))){
                    delete SPECIMEN[specimen]
                }
            }
            else if(!(specimens_.includes(specimen))){
                delete SPECIMEN[specimen]
            }
        });

        this.setState({
            tissueType: this.getKeyByValue(SPECIMEN, Object.keys(this.props.preview || {}).length === 0 ? this.props.defaultConfig.specimenType : this.props.preview.specimenType),
            scanSpeed: this.getKeyByValue(SCAN_SPEED, Object.keys(this.props.preview || {}).length === 0 ? this.props.defaultConfig.scanSpeed : this.props.preview.speed),
            objective: this.getKeyByValue(OBJECTIVE, Object.keys(this.props.preview || {}).length === 0 ? this.props.defaultConfig.objectiveType : this.props.preview.objectiveType),
        });
        this.createPreviewCanvasHelper();
    }

    createPreviewCanvasHelper() {
        let trayKey = this.props.cassetteKey;
        let rack = parseInt(trayKey.split("T")[0].split("R")[1]);
        let tray = parseInt(trayKey.split("T")[1]);

        const maskForPathCacheBusterKey = this.props.maskForPathCacheBusterKey;

        this.createPreviewCanvas(getOverlayedMaskForPath(this.props.slotId, tray, rack) + '?d=' + maskForPathCacheBusterKey);
    }

    componentDidUpdate = (prevProps) => {
        let prevPreviewStatus = prevProps.scanPreviewStatus;
        let currPreviewStatus = this.props.scanPreviewStatus;

        for (const [key, value] of Object.entries(currPreviewStatus)) {
            if (key === this.props.slotId) {
                if ((prevPreviewStatus[key] === undefined && value.previewStage === RegionSelectionConstants.FETCHED_IMAGE) ||
                (prevPreviewStatus[key] !== undefined && prevPreviewStatus[key].previewStage.toLowerCase() !== RegionSelectionConstants.FETCHED_IMAGE && 
                value.previewStage.toLowerCase() === RegionSelectionConstants.FETCHED_IMAGE)) {
                    this.props.dispatch(receivedPreviewStatus(ScanApiConstant.TAKEN_PREVIEW, value.previewResponse, key));
                }

                if ((prevPreviewStatus[key] === undefined && value.previewStage === RegionSelectionConstants.CONFIRMED) ||
                (prevPreviewStatus[key] !== undefined && ((prevPreviewStatus[key].previewStage.toLowerCase() !== RegionSelectionConstants.CONFIRMED && 
                value.previewStage.toLowerCase() === RegionSelectionConstants.CONFIRMED) || 
                (prevPreviewStatus[key].previewConfirmedCount !== value.previewConfirmedCount)))) {
                    this.confirmPreviewStatus(value.previewResponse);
                }
            }
        }

        if ((prevProps.preview || {}).status !== RegionSelectionConstants.FETCHED_IMAGE 
                && (this.props.preview || {}).status === RegionSelectionConstants.FETCHED_IMAGE) {
            let reg = {
                data: { index: 0 },
                height: 100,
                isChanging: false,
                new: false,
                width: 100,
                x: 0,
                y: 0,
            };
            this.createCanvas((this.props.preview || {}).specimenType, reg);
        }

        let preDDPoint = prevProps.slide_info?.dropDistancePoint[0];
        let newDDPoint = this.props.slideInfo?.dropDistancePoint[0];

        let ddPointChanged = false;
        if (preDDPoint !== undefined && newDDPoint !== undefined) {
            ddPointChanged = preDDPoint.x !== newDDPoint.x || preDDPoint.y !== newDDPoint.y;
        } else if ((preDDPoint === undefined && newDDPoint !== undefined) || (preDDPoint !== undefined && newDDPoint === undefined)) {
            ddPointChanged = true;
        }

        let newSlideStatus = this.props.slide_status;
        let prevSlideStatus = prevProps.slide_status;

        let newStatus = (newSlideStatus || {}).slideState;
        let prevStatus = (prevSlideStatus || {}).slideState;


        if (prevProps.maskForPathCacheBusterKey !== this.props.maskForPathCacheBusterKey || newStatus !== prevStatus || ddPointChanged){
            this.createPreviewCanvasHelper();
        }
    }

    componentWillUnmount = () => {
        this.setState({
            initialState,
        });
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return comparePropsAndState(this.props, nextProps, this.state, nextState);
    }

    thresholdCanvasRef = thresholdCanvas => this.thresholdCanvas = thresholdCanvas;

    previewCanvasRef = previewCanvas => this.previewCanvas = previewCanvas;

    createCanvas = (specimenTypeVal, reg) => {
        const thresholdContext = this.thresholdCanvas.getContext('2d');
        const thresholdImage = new Image();
		let date = new Date();
        let defaultMaskLocation = this.props.preview.response.defaultMaskLocation + "?d=" + date.getTime();
        if (specimenTypeVal === specimenType.HNE_TISSUE) {
            defaultMaskLocation = this.props.preview.response.defaultHneMaskLocation + "?d=" + date.getTime();
        } else if (specimenTypeVal === specimenType.IHC) {
            defaultMaskLocation = this.props.preview.response.defaultIhcMaskLocation + "?d=" + date.getTime();
        } else if (specimenTypeVal === specimenType.PAP) {
            defaultMaskLocation = this.props.preview.response.defaultPapMaskLocation + "?d=" + date.getTime();
        } else if (specimenTypeVal == specimenType.BM) {
            defaultMaskLocation = this.props.preview.response.defaultBmMaskLocation + "?d=" + date.getTime();
        }
        thresholdImage.src = "/dev-ssd/" + defaultMaskLocation;
        thresholdImage.onload = () => {
            thresholdContext.clearRect(0, 0, this.thresholdCanvas.width, this.thresholdCanvas.height);
            thresholdContext.drawImage(thresholdImage, 0, 0, this.thresholdCanvas.width, this.thresholdCanvas.height);
            this.calculateThreshold(reg);
        };
    }

    createPreviewCanvas = (previewPath) => {
        if (this.previewCanvas) {
            let ddPoints = this.props.slideInfo?.dropDistancePoint[0];
            const previewContext = this.previewCanvas.getContext('2d');
            previewContext.clearRect(0, 0, this.previewCanvas.width, this.previewCanvas.height);
            const previewImage = new Image();
            previewImage.src = previewPath;
            
            previewImage.onload = () => {
                this.previewCanvas.style.backgroundImage = `url(${previewPath})` 
            };

            if (ddPoints !== undefined){
                drawCrossHairInitial(ddPoints.x, ddPoints.y, this.previewCanvas, 
                    {clearCanvas: true, size: 10, color: 'red', width: 2}, 
                    {"response": this.props.slideInfo});
            }
        }
    }

    calculateThreshold = (reg) => {
        let imageURLData = this.thresholdCanvas.toDataURL("image/jpeg");
        let x1 = parseInt((reg.x * this.props.preview.response.previewWidth) / 100.0);
        let x2 = parseInt(((reg.x + reg.width) * this.props.preview.response.previewWidth) / 100.0);
        let y1 = parseInt((reg.y * this.props.preview.response.previewHeight) / 100.0);
        let y2 = parseInt(((reg.y + reg.height) * this.props.preview.response.previewHeight) / 100.0);
        let actualReg = [x1, y1, x2, y2];

        this.props.dispatch(setDeviceBusy(this.props.deviceId));
        const url = '/server/devices/' + this.props.deviceId + "/send_threshold_image_background/?slot_id=" + this.props.slotId;
        const data = {
            imgBase64: imageURLData, 
            specimenType: this.props.preview.specimenType,
            objectiveType: this.props.preview.objectiveType,
            actualRegion: actualReg,
            previewData: this.props.preview
        }
        post_response(url, data)
        .then(response => {
            if (response.status === 200) {
                this.props.dispatch(setPreviewStatusToConfirmed(this.props.slotId, reg, actualReg));
            }
            else {
                this.props.dispatch(receivedPreviewStatus(ScanApiConstant.ERRORED_WHILE_CONFIRMING_SELECTION, response, this.props.slotId))
                this.props.dispatch(setDeviceIdle(this.props.deviceId));
                message.error("Not able to confirm preview settings. Please contact admin.", 2.5);
                this.setState({
                    isFetching: false,
                });
            }
        })
        .catch(err => {
            this.props.dispatch(receivedPreviewStatus(ScanApiConstant.ERRORED_WHILE_CONFIRMING_SELECTION, err, this.props.slotId))
            this.props.dispatch(setDeviceIdle(this.props.deviceId));
            message.error("Not able to confirm preview settings. Please contact admin.", 2.5);
            this.setState({
                isFetching: false,
            });
        })
    }
    
    confirmPreviewStatus = (response) => {
        let region = this.props.preview.region !== undefined ? this.props.preview.region : {};
        let actualRegion = this.props.preview.actualRegion !== undefined ? this.props.preview.actualRegion : [];
        this.props.dispatch(setPreviewStatusToConfirmed(this.props.slotId, region, actualRegion));
        this.props.dispatch(setDropDistancePointOnly(this.props.slotId, response.dropDistancePoint));
        this.props.dispatch(setDropDistancePointLength(this.props.slotId, response.dropDistancePoint));
        this.props.dispatch(setFocusPoints(this.props.slotId, response.focusPoints));
        this.props.dispatch(setDeviceIdle(this.props.deviceId));
        this.props.dispatch(updatePreviewStatus(this.props.slotId, RegionSelectionConstants.CONFIRMED));
        this.setState({
            isFetching: false,
        });
    }

    getKeyByValue(object, value) {
        return Object.keys(object).find(key => object[key] === value);
    }

    setTissueType = (value) => {

        let isFetchingAllPreviews = false;

        let currPreviewStatus = this.props.scanPreviewStatus;

        for (const [key, value] of Object.entries(currPreviewStatus)) {
            if (value.previewOngoing) {
                console.trace("key", key, "value", value);
                isFetchingAllPreviews = true;
                break;
            }
        }

        this.setState({
            tissueType: value,
        });

        this.props.dispatch(setSpecimenType(this.props.slotId, SPECIMEN[value]));
        
        if (!(isFetchingAllPreviews || !((this.props.preview || {}).status === RegionSelectionConstants.CONFIRMED &&
        ((this.props.preview || {}).dropDistancePoint !== undefined && (this.props.preview || {}).dropDistancePoint.length > 0)))) {
            this.createCanvas(SPECIMEN[value], this.props.preview.region);
        }
    }

    setScanSpeed = (value) => {
        this.setState({
            scanSpeed: value,
        });
        this.props.dispatch(setScanSpeed(this.props.slotId, SCAN_SPEED[value]));
    }

    setObjectiveType = (value) => {
        this.setState({
            objective: value
        });
        this.props.dispatch(setObjectiveType(this.props.slotId, OBJECTIVE[value]));
    }

    expandEditor = () => {
        this.props.expandedSlideView(this.props.slotId);
    }

    openScan = (e, morphle_id) => {
        window.location.href = window.location.origin + getStateAwareUrl('') + `/server/v5/tissue/${morphle_id}/?url_prefix=${getStateAwareUrl('')}`
    }

    render() {
        const {
            slideStatus,
            cassetteKey,
            slotId,
            deviceId,
            mySlideType,
            maskForPathCacheBusterKey,
            showLoading,
            mockHalapi,
            slideStats,
            rackStatus
        } = this.props;

        const morphleId = (slideStatus.previewResponse || {}).morphleId;
        const beingUsedForPreviewCalibration = (slideStatus.previewResponse || {}).beingUsedForPreviewCalibration;
        const status = (slideStatus || {}).slideState;
        const scanAreaFinalized = (slideStatus || {}).scanAreaFinalized;
        const enoughScanArea = ((slideStatus || {}).previewResponse || {}).enoughScanArea;
        const stitchingPercentDone = (slideStats).stitchingPercentDone;
        let percentDone = (slideStats).percentDone;
        percentDone = percentDone === undefined || percentDone === null || isNaN(percentDone) ? 0.0 :
            percentDone.toFixed(2) <= 85 ? percentDone.toFixed(2) : 85.0;

        const mockHalapiStr = mockHalapi === undefined ? false : mockHalapi.toString();

        const trayKey = cassetteKey;
        const rack = parseInt(trayKey.split("T")[0].split("R")[1]);
        const tray = parseInt(trayKey.split("T")[1]);

        const slideMetaComponent = (
            <SlideMetaComponent
                slotId={slotId}
                rack={rack}
                tray={tray}
                scanAreaFinalized={scanAreaFinalized}
                slideStatus={status}
                previewCalibration={beingUsedForPreviewCalibration}
                SlideType={mySlideType}
            />
        );

        const slotImageCanvas = <canvas ref={this.previewCanvasRef} className={mySlideType === slideType.SLIDE_2_BY_3_INCH ? "c240-horizontal-slot-image-canvas-2by3" : "c240-horizontal-slot-image-canvas"} />;

        const barcodeComponent = (
            <BarcodeView
                slotId={slotId}
                slideState={status}
                SlideType={mySlideType}
                deviceId={deviceId}
                mockHalapiStr={mockHalapiStr}
                rack={rack}
                tray={tray}
                rackStatus={rackStatus}
                barcodeCacheBusterKey={maskForPathCacheBusterKey}
            />
        );

        let slideComponent = null;
        if (status === C240SlideStatus.PREVIEW_DONE) {
            slideComponent = <Row className={mySlideType === slideType.SLIDE_2_BY_3_INCH ?
                                  "centered c240-filled-preview-container-2by3" : "centered c240-horizontal-filled-preview-container"}>
                        {slideMetaComponent}
                        {(!isTrue(enoughScanArea)) ?
                        <Tooltip
                            placement="top"
                            title={"No tissue selected"} visible={!this.props.blockUI} zIndex={0}>
                            <Col onClick={this.expandEditor} className={ mySlideType === slideType.SLIDE_2_BY_3_INCH ? "horizontal-filled-slide-2by3" : "horizontal-filled-slide"}>
                                {slotImageCanvas}
                            </Col>
                        </Tooltip> :
                        <Tooltip
                            placement="top"
                            title={"Click to modify scan settings"}>
                            <Col onClick={this.expandEditor} className={ mySlideType === slideType.SLIDE_2_BY_3_INCH ? "horizontal-filled-slide-2by3" : "horizontal-filled-slide"}>
                                {slotImageCanvas}
                            </Col>
                        </Tooltip>
                        }
                        {barcodeComponent}
                    </Row>
        } else if (checkPreviewNotDoneSlideStatus(status)) {
            slideComponent = <Row className={ mySlideType === slideType.SLIDE_2_BY_3_INCH ?
                                  "centered c240-empty-unconfirmed-preview-container-2by3" :
                                  "centered c240-horizontal-empty-unconfirmed-preview-container" }
                         >
                        {slideMetaComponent}
                        <Col className={ mySlideType === slideType.SLIDE_2_BY_3_INCH ? "centered horizontal-empty-slide-2by3" : "centered horizontal-empty-slide"} >
                        </Col>
                        {barcodeComponent}
                    </Row>
        } else if( status === C240SlideStatus.SCAN_IN_QUEUE) {
            slideComponent = <Row className={mySlideType === slideType.SLIDE_2_BY_3_INCH ?
                        "centered c240-empty-confirmed-preview-container-2by3" :
                        "centered c240-horizontal-empty-unconfirmed-preview-container"}>
                        {slideMetaComponent}
                        <Col className={mySlideType === slideType.SLIDE_2_BY_3_INCH ? "horizontal-filled-slide-2by3" : "horizontal-filled-slide"} style={{cursor:'alias'}}>
                            {slotImageCanvas}
                        </Col>
                        {barcodeComponent}
                    </Row>
        } else if (status === C240SlideStatus.SCAN_ONGOING) {
            slideComponent = <Row className={mySlideType === slideType.SLIDE_2_BY_3_INCH ?
                                  "centered c240-empty-confirmed-preview-container-2by3" :
                                  "centered c240-horizontal-empty-confirmed-preview-container"}>
                        {slideMetaComponent}
                        <Col className={mySlideType === slideType.SLIDE_2_BY_3_INCH ? "horizontal-filled-slide-2by3" : "horizontal-filled-slide"}>
                            <div className={"progress-circle"}>
                                <Progress type="circle"
                                percent={percentDone}
                                width={80} />
                            </div>
                            {slotImageCanvas}
                        </Col>
                        {barcodeComponent}
                    </Row>
        } else if (this.props.slideState === C240SlideStatus.SCAN_DONE) {
            slideComponent = <Row className={
                mySlideType === slideType.SLIDE_2_BY_3_INCH ? 
            "centered c240-empty-confirmed-preview-container-2by3": 
            "centered c240-horizontal-empty-confirmed-preview-container"}>
                        {slideMetaComponent}
                        <Col onClick={(e)=>this.openScan(e, morphleId)} 
                        className={mySlideType === slideType.SLIDE_2_BY_3_INCH ? "horizontal-filled-slide-2by3" : "horizontal-filled-slide"}
                         style={{cursor:'pointer'}}>
                            {/* <p>Click to view scan</p> */}
                            <div className={"progress-circle"}>
                                <Progress type="circle" percent={100} width={80} style={{cursor:'pointer'}}/>
                            </div>
                            {slotImageCanvas}
                        </Col>
                        {barcodeComponent}
                    </Row>
        } else if (this.props.slideState === C240SlideStatus.SCAN_STITCHING) {
            slideComponent = <Row className={mySlideType === slideType.SLIDE_2_BY_3_INCH ?
                        "centered c240-empty-confirmed-preview-container-2by3" :
                        "centered c240-horizontal-empty-confirmed-preview-container"}>
                        {slideMetaComponent}
                        <Col className={mySlideType === slideType.SLIDE_2_BY_3_INCH ? "horizontal-filled-slide-2by3" : "horizontal-filled-slide"} style={{cursor:'alias'}}>
                            <div className={"progress-circle"}>
                                <Progress type="circle"
                                                    percent={stitchingPercentDone?stitchingPercentDone.toFixed(2):0}
                                width={60} />
                                <p style={{color: "white", margin: "0"}}>Stitching</p>
                            </div>                            
                            {slotImageCanvas}
                        </Col>
                        {barcodeComponent}
                    </Row>
        } else if (this.props.slideState === C240SlideStatus.SCAN_CRASHED) {
            slideComponent = <Row className={mySlideType === slideType.SLIDE_2_BY_3_INCH ?
                                  "centered c240-empty-unconfirmed-preview-container-2by3" :
                                  "centered c240-horizontal-empty-unconfirmed-preview-container"}>
                        {slideMetaComponent}
                        <Col className={mySlideType === slideType.SLIDE_2_BY_3_INCH ? "centered horizontal-empty-slide-2by3" : "centered horizontal-empty-slide"}>
                            <div>
                                <div>Scan crashed !</div>
                            </div>
                        </Col>
                        {barcodeComponent}
                    </Row>
        }

        let toolTipMessage = C240ControlPanelTooltipMessageMap(status);
        const highlightSlot = this.props.highlightSlideKey === slotId && this.props.highlight
        return (
            <Spin indicator={<Icon type="loading" style={{fontSize: 24, color: "black"}} spin/>}
                  style={{color: "black"}}
                  spinning={checkInQueueSlideStatus(status) || (showLoading !== undefined && showLoading)}
                  tip={toolTipMessage === undefined ?
                      (this.props.deviceBusyMessage) : toolTipMessage}>
                <div className='c240-horizontal-slide-container'>
                    <div style={highlightSlot ? {animation: "slot-pulse-focus 1s infinite"} : {}}>
                        {slideComponent}
                        <canvas ref={this.thresholdCanvasRef} className="region-selection-canvas-new"
                                style={{display: 'none'}}/>
                    </div>
                </div>
            </Spin>
        )
    }
}

    const mapStateToProps = (state, ownProps) => {
    let deviceStatus = state.deviceStatusReducer;
    let c240DeviceStatus = state.c240DeviceStatusReducer;
    const slideId = `${ownProps.cassetteKey}S${ownProps.slotId}`;
    const scannerResponse =
        (((deviceStatus || {})[ownProps.deviceId] || {}).scanner_health || {}).scanner_response || {};
    return {
        preview: state.previewStatusReducer[ownProps.slotId],
        scanPreviewStatus: scannerResponse.scanPreviewStatus,
        deviceBusyMessage: deviceStatus[ownProps.deviceId].busyMessage,
        supportedSpecimenTypes: scannerResponse.supportedSpecimenTypes,
        mockHalapi: (scannerResponse.mockConfig || {}).mockHalapi,
        slideStats: ((scannerResponse.currentSlideLevelStats || {})[slideId] || {}),
        rackStatus: ((c240DeviceStatus.data || {}).rack_module || {}).RACK
    };
};

export default connect(mapStateToProps, null, null, { forwardRef: true })(C240SlideView);